<template>
    <AppDialog v-model="isOpen" @close="resetModal">

        <div class="d-flex flex-column modal-header pb-4 pe-4 ps-4 pt-5">
          <div class="d-flex justify-content-between w-100 mb-4">
            <h5 class="modal-title">{{ $t("Share Products Sets") }}</h5>

              <div class="d-flex gap-3 align-items-center">
                  <div>{{$t('n-selected-products', {num: calculateSelectedNum()})}}</div>
                  <!--begin::Close-->
                  <div class="btn btn-icon btn-sm btn-active-light-primary ms-2 bg-gray-200 w-30px h-30px"
                       data-bs-dismiss="modal" aria-label="Close">
                      <span class="bi bi-x fs-2 text-gray-400 fw-bold d-flex"></span>
                  </div>
                  <!--end::Close-->
              </div>
          </div>

          <div class="search-dev d-flex justify-content-between w-100 gap-4">
            <!--begin::Input search-->
            <div class="w-100 position-relative">
              <!--begin::search icon-->
              <div class="position-absolute translate-middle-y top-50 start-16px me-3"
                :class="locale == 'ar' ? 'start-16px' : 'end-16'">
                <!--begin::Svg Icon | path: icons/duotune/finance/fin002.svg-->
                <span class="bi bi-search"></span>
                <!--end::Svg Icon-->
              </div>
              <!--end::search icon-->
              <!--begin::Input-->
              <input v-model="searchQuery" type="text"
                class="form-control form-control-solid ps-10 bg-white border-grey-400" maxlength="100"
                :placeholder="$t('search or name product')" name="search" />
              <!--end::Input-->
            </div>
            <!--end::Input search-->
            <!-- <a href="#" class="bg-white border border-grey-900 btn btn-light d-flex p-3 text-center w-auto"><span
                class="bi bi-filter d-flex m-auto"></span></a> -->
          </div>
          <div v-if="loading" class="loading-line">
          </div>
        </div>

        <div class="modal-body p-4 h-500px scroll-y" id="model_products" @scroll="handleScroll">
          <!-- Start Products -->
          <div class="products">
            <template v-for="(product, index) in listProduct" :key="`product${product.id}-${index}`">

              <label class="d-flex cursor-pointer mb-4" v-if="product.variants[0].options_count == 0">
                <!--begin:Input-->
                <span class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input me-4" v-model="checkedItems" :value="product.id"
                    :checked="checkedItems.includes(product.id)" type="checkbox" name="category"
                    @change="(e) => getProduct(e, product)"
                    :disabled="isDisableProduct(product, false)"/>
                </span>
                <!--end:Input-->
                <!--begin:Label-->
                <span class="d-flex align-items-center  w-100">
                  <!--begin:Icon-->
                  <span class="symbol symbol-50px me-6">
                    <span class="symbol-label bg-light-success">
                      <!--begin::Svg Icon | path: icons/duotune/general/gen013.svg-->
                      <span class="svg-icon svg-icon-1 svg-icon-danger h-50px w-50px rounded">
                        <img :src="product.product_image?.image_thumbnail_url ?? loadFile(images.logo)"
                          class="h-50px w-50px rounded" alt="" />
                      </span>
                      <!--end::Svg Icon-->
                    </span>
                  </span>
                  <!--end:Icon-->

                  <!--begin:Info-->
                  <span class="d-flex flex-column">
                    <span class="fw-bolder fs-6">{{ product.available_name }}</span>
                    <span class="fs-7 text-muted">#{{ product.variants[0].vendor_stock_code }}</span>
                  </span>
                  <!--end:Info-->
                  <!--begin:price-->
                  <span class="d-flex flex-column ms-auto text-nowrap">
                    <span class="fw-bolder fs-6">{{ product.variants[0].price }} {{
              product.variants[0].currency.short_code }}</span>
                  </span>
                  <!--end:price-->
                </span>
                <!--end:Label-->
              </label>
              <div class="accordion" :id="`head_product_${product.id}`" v-else>
                <div class="accordion-item border-0">
                  <h2 class="accordion-header" :id="`head_product_${product.id}_header_1`">
                    <button class="accordion-button collapsed fs-4 fw-bold mb-4 p-0" type="button"
                      data-bs-toggle="collapse" :data-bs-target="`#head_product_${product.id}_body_1`"
                      aria-expanded="true" :aria-controls="`head_product_${product.id}_body_1`">
                      <!--begin:Option-->
                      <label class="d-flex cursor-pointer mb-4">
                        <!--begin:Label-->
                        <span class="d-flex align-items-center me-2 w-100">
                          <span class="form-check form-check-custom form-check-solid">
                            <input :id="product.id" class="form-check-input me-4" type="checkbox" name="category"
                              v-model="checkedItems" :value="product.id" @change="(e) => getAllVariants(e, product)"
                              :disabled="isDisableProduct(product, false)">
                          </span>
                          <!--begin:Icon-->
                          <span class="symbol symbol-50px me-6">
                            <span class="symbol-label bg-light-success">
                              <!--begin::Svg Icon | path: icons/duotune/general/gen013.svg-->
                              <span class="svg-icon svg-icon-1 svg-icon-danger h-50px w-50px rounded">
                                <img :src="product.product_image?.image_thumbnail_url ?? loadFile(images.logo)"
                                  class="h-50px w-50px rounded" alt="" />
                              </span>
                              <!--end::Svg Icon-->
                            </span>
                          </span>
                          <!--end:Icon-->

                          <!--begin:Info-->
                          <span class="d-flex flex-column">
                            <span class="fw-bolder fs-6"> {{ product.available_name }}</span>
                            <!-- <span class="fs-7 text-muted">#{{ product.sku }}</span> -->
                          </span>
                          <!--end:Info-->
                        </span>
                        <!--end:Label-->
                      </label>
                      <!--end::Option-->
                    </button>
                  </h2>
                  <div :id="`head_product_${product.id}_body_1`" class="accordion-collapse collapse"
                    aria-labelledby="kt_accordion_1_header_1" :data-bs-parent="`#head_product_${product.id}_body_1`">
                    <div class="accordion-body pe-0">
                      <template v-for="(variant, variant_index) in product.variants"
                        :key="`product${product.id}-${variant.id}-${variant_index}`">
                        <!--begin:Option-->
                        <label class="d-flex cursor-pointer mb-4  ms-4">
                          <!--begin:Input-->
                          <span class="form-check form-check-custom form-check-solid">
                            <input :id="`${product.id}-${variant.id}`" v-model="checkedItems"
                              :value="`${product.id}-${variant.id}`" class="form-check-input me-4" type="checkbox"
                              name="category" @change="(e) => getSingleVariant(e, product, variant)"
                                   :disabled="isDisableProduct(variant, true)"/>
                          </span>
                          <!--end:Input-->
                          <!--begin:Label-->
                          <span class="d-flex align-items-center  w-100">
                            <!--begin:Info-->
                            <span class="d-flex flex-column">
                              <span class="fw-bolder fs-6">
                                <template v-for="(option_value, index_option_value) in variant.option_values"
                                  :key="`option${product.id}-${variant.id}-${variant_index}-${index_option_value}`">
                                  <span
                                    class='me-2 badge badge-light text-black bg-white border rounded-2 border-secondary lh-0 py-3 mb-1'>
                                    {{ option_value.available_name }}
                                  </span>
                                </template>

                              </span>
                              <span class="fs-7 text-muted">#{{ variant.vendor_stock_code }}</span>
                            </span>
                            <!--end:Info-->
                            <!--begin:price-->
                            <span class="d-flex flex-column ms-auto text-nowrap">
                              <span class="fw-bolder fs-6">{{ variant.price }} {{ variant.currency.short_code }}</span>
                            </span>
                            <!--end:price-->
                          </span>
                          <!--end:Label-->
                        </label>
                        <!--end::Option-->
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <!--begin:Option-->
            <!--end::Option-->
          </div>
          <!-- End Products -->
          <div v-if="loadingAppend" class="d-block m-auto spain spinner-border spinner-border-sm"></div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            {{ $t("cancel") }}
          </button>
          <button type="button" :disabled="sendMessageLoading || multiProduct.length == 0"
            @click="emit('shareProducts', catalog_id)" class="btn btn-submit text-white" data-bs-dismiss="modal">
            <div v-if="sendMessageLoading">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ $t("Sending") }}
            </div>
            <span v-else>{{ $t("Send") }}</span>
          </button>
        </div>
  </AppDialog>
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";
import axios from "axios";
import { useStore } from 'vuex';
import { loadFile } from '@/components/utils.js'
import AppDialog from './../../shared/AppDialog';

const emit = defineEmits(['shareProducts', 'close']);

const props = defineProps({
  locale: {
    type: String,
  },
});

const store = useStore();

const base_url = window.location.origin;
const listProduct = ref([]);
const current_page = ref(1);
const next_page_url = ref(null);
const per_page = ref(10);
const catalog_id = ref('')
const multiProduct = ref('')
const checkedItems = ref([]);

const images = {
  logo: 'linker_placeholder.png'
}

const sendMessageLoading = computed(() => store.state?.Chat?.sendMessageLoading);

watch(() => store.state?.WhatsappShare?.multiProduct, (newVal) => {
  multiProduct.value = newVal
});

const getProduct = (e, product) => {
  const { translations, variants } = product
  const productVariant = variants.length > 0 ? variants[0] : {}
  const localeTranslation = translations?.find(elem => elem.locale == props.locale)
  const variantExtraData = productVariant?.linked_marketplace_product?.extra_data?.products
  const variantCatalogId = Array.isArray(variantExtraData) ? variantExtraData.length > 0 ? variantExtraData[0]?.catalog_id : '' : ''
  catalog_id.value = variantCatalogId
  const data = {
    action: {
      "catalog_id": variantCatalogId,
      "product_retailer_id": productVariant?.linked_marketplace_product?.sku
    },
    "extra_data": {
      "product_name": localeTranslation ? localeTranslation?.title ?? product.title : product.title,
      "price": `${productVariant?.price} ${productVariant?.currency?.code}`,
      "image": product?.product_image?.image_thumbnail_url
    },
  }
  if (e?.target?.checked) {
    if (!checkedItems.value.includes(product.id))
      checkedItems.value.push(product.id);
    store.commit('WhatsappShare/addProductToMulti', data);

  } else {
    checkedItems.value = checkedItems.value.filter((item) => item !== product.id);
    store.commit('WhatsappShare/removeSingleFromMultiple', data);
  }
}

const getAllVariants = (e, product) => {
  changeNestedCheckboxState(product, e?.target?.checked)
  const { translations, variants } = product
  const localeTranslation = translations?.find(elem => elem.locale == props.locale)
  const products = variants.map((productVariant) => {
    const variantExtraData = productVariant?.linked_marketplace_product?.extra_data?.products
    const variantCatalogId = Array.isArray(variantExtraData) ? variantExtraData.length > 0 ? variantExtraData[0]?.catalog_id : '' : ''
    catalog_id.value = variantCatalogId
    return {
      action: {
        "catalog_id": variantCatalogId,
        "product_retailer_id": productVariant?.linked_marketplace_product?.sku
      },
      "extra_data": {
        "product_name": localeTranslation ? localeTranslation?.title ?? product.title : product.title,
        "price": `${productVariant?.price} ${productVariant?.currency?.code}`,
        "image": product?.product_image?.image_thumbnail_url
      },
    }
  })
  if (e?.target?.checked) {
    if (!checkedItems.value.includes(product.id))
      checkedItems.value.push(product.id);

    variants.forEach(variant => {
      if (!checkedItems.value.includes(`${product.id}-${variant.id}`))
        checkedItems.value.push(`${product.id}-${variant.id}`);
    })
    store.commit('WhatsappShare/addMultiToMulti', products);
  } else {
    checkedItems.value = checkedItems.value.filter((item) => item != product.id);
    variants.forEach(variant => {
      checkedItems.value = checkedItems.value.filter((item) => item !== `${product.id}-${variant.id}`);
    })
    store.commit('WhatsappShare/removeMultiFromMulti', products);
  }
}

const getSingleVariant = (e, product, variant) => {
  changeParentCheckboxState(e, product)

  const { translations } = product
  const localeTranslation = translations?.find(elem => elem.locale == props.locale)
  const variantExtraData = variant?.linked_marketplace_product?.extra_data?.products
  const variantCatalogId = Array.isArray(variantExtraData) ? variantExtraData.length > 0 ? variantExtraData[0].catalog_id : '' : ''
  catalog_id.value = variantCatalogId
  const data = {
    action: {
      "catalog_id": variantCatalogId,
      "product_retailer_id": variant?.linked_marketplace_product?.sku
    },
    "extra_data": {
      "product_name": localeTranslation ? localeTranslation?.title ?? product.title : product.title,
      "price": `${variant?.price} ${variant?.currency?.code}`,
      "image": product?.product_image?.image_thumbnail_url
    },
  }
  if (e?.target?.checked) {
    if (!checkedItems.value.includes(`${product.id}-${variant.id}`))
      checkedItems.value.push(`${product.id}-${variant.id}`);

    store.commit('WhatsappShare/addProductToMulti', data);
  } else {
    checkedItems.value = checkedItems.value.filter((item) => item !== `${product.id}-${variant.id}`);
    store.commit('WhatsappShare/removeSingleFromMultiple', data);
  }
}

const changeParentCheckboxState = (e, product) => {
  if (typeof document === 'undefined') return;
  if (!Array.isArray(product?.variants)) return
  if (product?.variants.length == 1) return


  let toChange = true
  product.variants.forEach(element => {
    const checkbox = document.getElementById(`${product.id}-${element.id}`)
    if (checkbox && !checkbox?.checked) toChange = false
  });
  const productCheckbox = document.getElementById(product.id)
  if (productCheckbox) productCheckbox.checked = toChange
  if (toChange) {
    if (!checkedItems.value.includes(product.id))
      checkedItems.value.push(product.id);

  }
  else {
    checkedItems.value = checkedItems.value.filter((item) => item != product.id);
  }
}

const changeNestedCheckboxState = (product, newState) => {
  if (typeof document === 'undefined') return;
  if (!Array.isArray(product?.variants)) return
  product.variants.forEach(element => {
    const checkbox = document.getElementById(`${product.id}-${element.id}`)
    checkbox.checked = newState
  });
}
const searchQuery = ref('');
const loading = ref(false);
const loadingAppend = ref(false);
const isOpen = ref(false);


const handleScroll = () => {
  if (next_page_url.value === null) return '';

  const modalBody = document.querySelector('#model_products');
  if (!modalBody) return;

  const scrollPosition = modalBody.scrollTop + modalBody.clientHeight;
  const maxScroll = modalBody.scrollHeight - 20;

  if (scrollPosition >= maxScroll) {
    const append = true;
    fetchProducts(append);
  }
};
const fetchProducts = async (append = false) => {
  if (loading.value) return '';

  try {
    loading.value = true;
    if (append)
      loadingAppend.value = true;

    const response = await axios.get(`${base_url}/api/products/ajax-products-with-variants`, {
      params: {
        search: searchQuery.value,
        marketplace_id: 8,
        status: 'LISTED',
        page: append ? (current_page.value + 1) : 1,

      },
    });
    if (append) {
      listProduct.value = [...listProduct.value, ...response?.data?.result?.products.data];
    }
    else {
      listProduct.value = response?.data?.result?.products.data;
    }
    current_page.value = response?.data?.result?.products?.current_page;
    per_page.value = response?.data?.result?.products?.per_page;
    next_page_url.value = response?.data?.result?.products?.next_page_url;

  } catch (error) {
    console.log("error in fetch product");
  } finally {
    // Reset loading state regardless of outcome
    loading.value = false;
    loadingAppend.value = false;

  }
};
const resetModal = () => {
  checkedItems.value = [];
  store.commit('WhatsappShare/clearMultipleProducts');
  searchQuery.value = '';
  next_page_url.value = null;
  current_page.value = null;
  emit('close');
}

const open = () => {
  isOpen.value = true;
  fetchProducts();
};


onMounted(() => {
  fetchProducts()
  const modalElement = document.getElementById('kt_modal_share_products');

  if (modalElement) {
    modalElement.addEventListener('hidden.bs.modal', resetModal);
  }
});

let debounceTimer;

const debouncedFetchProducts = () => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => {
    current_page.value = 1;
    fetchProducts();
  }, 600);
};
watch(searchQuery, () => {
  debouncedFetchProducts();
});

const isDisableProduct = (item, isVariant) => {
    // console.log("isDisableProduct - item", calculateSelectedNum());

    let vendorStockCode = !isVariant ? item?.id : item?.product_id+'-'+item.id;
    return calculateSelectedNum() + (isVariant ? 1 : item?.variants?.length) > 30 && checkedItems.value?.findIndex(el=> el === vendorStockCode) ===-1;
};

const calculateSelectedNum = () =>{
    let newArr = [];
    checkedItems.value.forEach(item =>{
        let hasChildren = false;
        if(typeof item == 'number'){
            hasChildren = checkedItems.value.some(el => typeof el === 'string' && el.split('-')?.[0] == item);
        }
        if(!hasChildren) newArr.push(item);
    });
    return newArr.length;
}

defineExpose({
  open,
});
</script>

<style scoped lang="scss">
.modal-title {
  line-height: 24px;
  font-weight: 600;
  font-size: 20px;
}

.start-16px {
  right: 16px;
}

.end-16px {
  left: 16px;
}

.btn-submit {
  border: 1px solid #ef7048;
  background-color: #ef7048;
}

.accordion-button:not(.collapsed) {
  color: inherit;
  background-color: inherit;
}

.loading-line {
  height: 4px;
  width: 100%;
  --c: no-repeat linear-gradient(#CBCCCE 0 0);
  background: var(--c), var(--c), #e3eaf8;
  background-size: 60% 100%;
  animation: l16 3s infinite;
}

@keyframes l16 {
  0% {
    background-position: -150% 0, -150% 0
  }

  66% {
    background-position: 250% 0, -150% 0
  }

  100% {
    background-position: 250% 0, 250% 0
  }
}
</style>
